module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "row"
  }, [(_vm.loading.templates) ? _c('spinner') : _c('form', {
    attrs: {
      "data-vv-scope": "email-template"
    }
  }, [_c('div', {
    staticClass: "col-md-5"
  }, [_c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.errors.has('email-template.email-template-name')
    }
  }, [_c('label', {
    attrs: {
      "for": "email-template-name"
    }
  }, [_vm._v("* Template name")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.template.name),
      expression: "template.name"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "email-template-name",
      "placeholder": "Template Name",
      "name": "email-template-name",
      "data-vv-as": "Template Name"
    },
    domProps: {
      "value": (_vm.template.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.template, "name", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('email-template.email-template-name')),
      expression: "errors.has('email-template.email-template-name')"
    }],
    staticClass: "help-block"
  }, [_vm._v(_vm._s(_vm.errors.first('email-template.email-template-name')))])]), _vm._v(" "), _c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.errors.has('email-template.email-template-subject')
    }
  }, [_c('label', {
    attrs: {
      "for": "email-template-body"
    }
  }, [_vm._v("* Subject")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.template.subject),
      expression: "template.subject"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "rows": "2",
      "placeholder": "Subject",
      "name": "email-template-subject",
      "data-vv-as": "Subject"
    },
    domProps: {
      "value": (_vm.template.subject)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.template, "subject", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('email-template.email-template-subject')),
      expression: "errors.has('email-template.email-template-subject')"
    }],
    staticClass: "help-block"
  }, [_vm._v(_vm._s(_vm.errors.first('email-template.email-template-subject')))])]), _vm._v(" "), _c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.errors.has('email-template.email-template-header')
    }
  }, [_c('label', {
    attrs: {
      "for": "email-template-header"
    }
  }, [_vm._v("* Header Banner")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.template.header),
      expression: "template.header"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "email-template-header",
      "placeholder": "Header (Banner)",
      "name": "email-template-header",
      "data-vv-as": "Header (Banner)"
    },
    domProps: {
      "value": (_vm.template.header)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.template, "header", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('email-template.email-template-header')),
      expression: "errors.has('email-template.email-template-header')"
    }],
    staticClass: "help-block"
  }, [_vm._v(_vm._s(_vm.errors.first('email-template.email-template-header')))])]), _vm._v(" "), _c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.errors.has('email-template.email-template-sincerely')
    }
  }, [_c('label', {
    attrs: {
      "for": "email-template-sender"
    }
  }, [_vm._v("* Sincerely,")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.template.sender),
      expression: "template.sender"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "email-template-sender",
      "name": "email-template-sincerely",
      "data-vv-as": "Sincerely"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.template, "sender", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "disabled": "",
      "selected": ""
    },
    domProps: {
      "value": null
    }
  }, [_vm._v("Select option...")]), _vm._v(" "), _vm._l((_vm.newEmailOptions.senders), function(sender, senderKey) {
    return _c('option', {
      domProps: {
        "value": senderKey
      }
    }, [_vm._v(_vm._s(sender.name) + " <" + _vm._s(sender.email) + ">")])
  })], 2), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('email-template.email-template-sincerely')),
      expression: "errors.has('email-template.email-template-sincerely')"
    }],
    staticClass: "help-block"
  }, [_vm._v(_vm._s(_vm.errors.first('email-template.email-template-sincerely')))])]), _vm._v(" "), _c('button', {
    staticClass: "btn green",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.saveTemplate(false)
      }
    }
  }, [_vm._v("Save")]), _vm._v(" "), _c('button', {
    staticClass: "btn green",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.saveTemplate(true)
      }
    }
  }, [_vm._v("Save and Send Email")]), _vm._v(" "), _c('button', {
    staticClass: "btn default",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.$emit('back')
      }
    }
  }, [_vm._v("Back")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-7"
  }, [_c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.errors.has('email-template.email-template-body')
    }
  }, [_c('label', {
    attrs: {
      "for": "email-template-body"
    }
  }, [_vm._v("* Body")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.template.body),
      expression: "template.body"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "rows": "20",
      "id": "email-template-body",
      "placeholder": "Body",
      "name": "email-template-body",
      "data-vv-as": "Body"
    },
    domProps: {
      "value": (_vm.template.body)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.template, "body", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('email-template.email-template-body')),
      expression: "errors.has('email-template.email-template-body')"
    }],
    staticClass: "help-block"
  }, [_vm._v(_vm._s(_vm.errors.first('email-template.email-template-body')))])])])])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5cb7a5dd","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/emails/EditTemplate.vue
// module id = 1656
// module chunks = 1